<template>
	<div class="header">
		  <Dialog :showAppDia.sync="showAppDia" ></Dialog>
		  <Dialog :weanly.sync="weanly" ></Dialog>
		  <Dialog :customerDia.sync="customerDia" ></Dialog>
		  <transition name="hehe">
		   <customer-Chat v-if="showTrue" @closeDia="showTrue=false" :receiveItems="receiveItems" />
	      </transition>
		  <div class="header-title">
			<div style="display: flex;align-items: center;">
				<!-- <div class="line_wrapper" @click="showBos()">
					<span class="line"></span>
					<span class="line"></span>
					<span class="line"></span>
				</div> -->
				
				<div class="title-desc" >{{  isShopsoo ? $t('other.a1789') : $t('header.title')}}</div>
				
			</div>
			
		    <!-- <div class="login-btn" v="!haslogin">登录</div> -->
			<div class="ttp">
				<!-- <div class="box" >
					<p class="animate">新消息提醒！ 2021.02.07  20：00进行系统维护，期间可能会有部分功能失效，预计维护时间1小时，21：00恢复正常！</p>
				</div> -->
				<!-- <div v-if="!isShopsooo" class="cinlg" @click="weanly =true">
					<span>{{$t('other.a1790')}}</span>
				</div> -->

				<div class="cinlg" @click="showAppDia =true" v-if="!isShopsooo">
					<i class="iconfont icon-shoujiduan tubiao"></i>
					<span>{{$t('other.a1791')}}</span>
				</div>
				<div class="cinlg" @click="geToHelpe()">
					<i class="iconfont icon-wendang tubiao"></i>
					<span>{{$t('other.a1792')}}</span>
				</div>
			    <div class="cinlg" @click="showChat('systemAdmin','技术人员')">
					<i class="iconfont icon-tubiaozhizuo-- tubiao"></i>
					<span>{{$t('other.a1793')}}</span>
				</div>

				<div class="cinlg" >
					<i class="iconfont icon-kefu2 tubiao"></i>
					<span @click="customerDia=true">{{$t('other.a3')}}</span>
				</div>
				
				<!-- <el-dropdown>
				<span class="el-dropdown-link">
					<div class="cinlg" >
						<i class="iconfont icon-kefucopy kefuTubiao tubiao"></i>
						<span>{{userPos === 'STORE' ? '联系卖家' : '联系仓库'}}</span>
					</div>
				</span>
				<el-dropdown-menu class="project-dropdown" slot="dropdown">
					<el-dropdown-item @click.native="showChat(item.userId,item.userName)" v-for="(item,index) in customerList" :key="index">
						<template>
							<span class="">与 {{item.userName}} 进行会话</span>
						</template>
					</el-dropdown-item>
				</el-dropdown-menu>
				</el-dropdown> -->
				<div style="cursor: pointer;" @mouseenter="isShow =true" @mouseleave="gto()">
					<span v-show="unreadNum!==0" style="font-size: 18px;margin-right: 20px;">
						<i class="iconfont icon-xiaoxitixing news"></i>
						<span style="font-size:14px">{{unreadNum}}{{$t('other.a1794')}}</span>
					</span>
					<span v-show="unreadNum==0" style="font-size: 16px;margin-right: 20px;" @click="replyAnswer('system')">
						<i class="iconfont icon-xiaoxitixing "></i>
					</span>
				</div>
				<el-select class="toggle" size="mini" @change="switchLangq(value)" v-model="value" placeholder="Language">
				    <el-option
				      v-for="item in options"
				      :key="item.value"
				      :label="item.label"
				      :value="item.value">
				    </el-option>
				 </el-select>
				  <span>{{$t('header.huanyinru')}}：</span>{{userName}} 
				<el-dropdown>
				  <span class="el-dropdown-link">
					<i class="iconfont icon-gerenzhongxin"></i>
				  </span>
				  <el-dropdown-menu slot="dropdown">
					 <el-dropdown-item @click.native="gotopersonal()"><span >{{$t('other.a341')}}</span></el-dropdown-item>
				    <el-dropdown-item @click.native="signOut()"><span >{{$t('other.a1795')}}</span></el-dropdown-item>
				  </el-dropdown-menu>
				</el-dropdown>
				<transition name="fade">
					<div class="notice" :class="{'active': isShow}" @mouseenter="isShow01 =true" @mouseleave="isShow01 =false,isShow =false">
						<div v-if="unreadNum==0" style="line-height: 300px;text-align: center;">{{$t('other.a1796')}}</div>
						<div style="padding:5px 0;" v-if="unreadNum !==0" >{{$t('other.a964')}}{{unreadNum}}{{$t('other.a1797')}}</div>
						<div style="margin-top:10px">
							<div style="border-bottom:1px solid #eee" v-if="item.unreadCount !== 0" v-for="(item,index) in newList" :key="index">
								<div style="font-size:12px;color:#409eff">{{$t('other.a1800')}}“{{item.reciprocalName}}”的{{item.unreadCount}}{{$t('other.a1798')}}</div>
								<div style="font-size:12px;padding:5px 0;display:flex;justify-content: space-between;">
									<span class="new_desc">{{getRelaseNews(item,item.reciprocalId)}}</span>
									<span style="padding-right:15px;cursor: pointer;" @click="replyAnswer(item.reciprocalId)">{{$t('other.a1799')}}</span>
								</div>
							</div>
						</div>

					</div>
				</transition>
				
			</div>
		</div>

	</div>
</template>

<script>
	import { mapState, mapMutations, mapActions } from 'vuex'
	import customerChat from '../../components/customerChat'
	import Dialog from '../../components/dialog/dialog.vue'
	import api from '../../api/moudles/customer'
	import utils from '../../utils/utils'
	export default {
		data(){
			return {
				options: [{
					value: 'zh',
					label: '中文'
				}, {
					value: 'en',
					label: 'English'
				 },{
					value: 'th',
					label: 'Thailand'
				 },{
					value: 'vn',
					label: 'Vietnam'
				 },{
					value: 'my',
					label: 'Malaysia'
				 }],
				 value: 'zh',
				 isShow01:false,
				 isShopsooo:JSON.parse(localStorage.getItem('isShopsooo')),
				 isCollapse:false,
				 isShow:false,
				 showTrue:false,
				 receiveItems:null,
				 showAppDia:false,
				 customerList:[],
				 sysUnread:0,
				 othersUnread:0,
				 notify:null,
				 isShopsoo:false,
				 weanly:false,
				 customerDia:false,
				 isParnet:false,
			}
		},
		inject:['reload'],
		components:{
			customerChat,
			Dialog
			
		},
		computed:{
			...mapState({
				userName: state => state.shopaccess.userInfo.userName,
				userId: state => state.shopaccess.userInfo.userId,
				userPos: state => state.shopaccess.userInfo.userPos,
				warehose: state => state.shopaccess.warehouse,
				orderlist: state => state.order.unprocessOrder,
				haslogin: state => state.login.loginStatus,
				unreadNum: state => state.customer.unreadNum,
				newList: state => state.customer.newList,
				storeBindShopList: state=>state.deduction.storeBindShopList,
				userList: state => state.customer.userList,
				alltotal: state => state.customer.alltotal,
				
				
			}),
		},
		watch:{
			
			userList(){
				console.log(this.newList)
				if(this.newList.length> 0){
					this.newList.forEach(k => { 
							if(k.reciprocalId === '"systemAdmin"'){
								this.sysUnread=k.unreadCount
							}else{
								this.othersUnread=k.unreadCount
							}
						
					})

				}
				
			},

			newList(){
				console.log('newList',this.newList)
				let list=[]
				this.newList.forEach(p => {
					if(p.reciprocalId == "system"  && p.unreadCount > 0){
						p.messages.forEach(i =>  {
							if(!i.read && i.comeFrom == "system"){
								i.createTime=utils.renderTime(i.createTime)
								list.push(i)
							}
						})
						
					}
				})
				if(list.length){
					const h=this.$createElement
						 this.notify =this.$notify({
							title:list.length + this.$t('other.a1801'),
							dangerouslyUseHTMLString: true,
							message:h(
							"div",
								null,
								[
								h("div", 
								{
									class:'erp_notify'
								},
								list[list.length-1].createTime),
								h("div", 
								{
									class:'desc_notify'
								},
								list[list.length-1].msg),

								h(
									"button",
									{
									class: "notify_btn",
									on: {
										click: this.doSth,
									},
									},
									this.$t('other.a884'),
								),

								h(
									"span",
									{
									class: "more_notify",
									on: {
										click: this.vieMore,
									},
									},
									this.$t('other.a1802')+"("+list.length+')',
								),
								]
							),
							type: 'warning',
							position: 'top-right',
							duration: 100000,
							onClose: () => {
							
							}
						})

				}

				console.log('list',list)
			},

		},
		created(){
			let host=location.host
			if(host.indexOf('shopsooo') > -1){
				this.isShopsoo=true
			}
			console.log('host',host)
			setTimeout(() => {
				this.getMessage()
				this.init()
			},2000)
		},
	
		methods:{
			...mapMutations('login', [
				'SWITCH_LANG',
			]),

			...mapMutations('common', [
				'getAsideStatu',
			]),

			...mapActions('customer', [
				'getMessageInfo',
			]),

			vieMore(){
				this.showTrue=true
				this.notify.close() 
			},

		


			doSth(){
				this.notify.close() 
				let list=[]
				this.newList.forEach(p => {
					if(p.reciprocalId == "system"  && p.unreadCount > 0){
						p.messages.forEach(i =>  {
							if(!i.read && i.comeFrom == "system"){
								i.createTime=utils.renderTime(i.createTime)
								list.push({
									chatId:i.chatId
								})
							}
						})
						
					}
				})

				console.log('741',list)
				api
				.readMessage(list)
				.then(res => {
					if(res.code === 200) {
					
					}
				})
				
			},

			showBos(){
				this.getAsideStatu(true)
			},

			init(){

				let lang=localStorage.getItem('lang')
				this.value=lang ? lang : 'zh'


				if(this.userPos === "SELLER"){
					let options=null
					const warehouseList=JSON.parse(localStorage.getItem('warehouse')) 
					if(warehouseList) {
						options=warehouseList.map(item => {
							return {
								value:item.userId,
								label:item.storeName + "(" + item.userName + ")"
							}
						})
					}

					this.customerList=options.map(p => {
						return{
							userId:p.value,
							userName:p.label,
						}
					})

					

					console.log(this.customerList)


				}else if(this.userPos === "STORE"){
					
					let arr=utils.getSellerBystoreId()
					console.log(arr)

					this.customerList=arr.map(p => {
						return{
							userId:p.value,
							userName:p.label,
						}
					})

					console.log(this.customerList)
					

				}

			

			},

			showChat(userId,userName){
				console.log('userList',this.userList)
				let list =[]

				this.userList.forEach(p => {
					if(p.userAccount == userId){
						list.push(p)
					}
				})

				if(!list.length){
					this.userList.push({
						id:null,
						active:false,
						userName:userName,
						userAccount:userId,
						sessionInfo:this.$t('other.a1803')
					})

				}

			
			  
			  this.receiveItems={
				  name:userId
				}
				this.showTrue=true 
			  

		  },



			getRelaseNews(list,ttp){
				
				let arr=[]
				list.messages.forEach(p => {
					if(p.comeFrom === ttp && p.read ===false){
						arr.push(p)
					}
				})

				console.log('arr',arr)
				arr.sort((a,b) => {
					if(a.chatId - b.chatId > 0){
						return -1
					}
				})
				return arr[0].msg
			

				

			},

			geToHelpe(){
				if(this.isShopsoo){
					window.open('https://www.yuque.com/docs/share/a4df942c-49bc-4ed5-98b1-be8c5d1795c7?#')
				}else{

					window.open('https://www.yuque.com/dongtiandeyinghuochong/qtw9rm')
				}
			},

			//轮询消息提醒
			getMessage(){
				this.getMessageInfo({
					userId:this.userId,
					lastTime:0,
				})
				 
			},
			goTOchat(){
				this.$router.push({
					path: '/customer',
					query: {
						name: "systemAdmin",
					
					}
				});

			},

			replyAnswer(id){
				console.log(id)
				this.showTrue=true
				this.receiveItems={
					name:id
				}
				this.gto()

				console.log(this.receiveItems)
			},


			gto(){
				setTimeout(() => {
					if(this.isShow01){
					   this.isShow =true
					   this.isShow01=false
					}else{
						this.isShow =false
						this.isShow01=false
					}
					   
				},100)
			},
			signOut(){
				localStorage.removeItem('userInfo')
				localStorage.removeItem('warehouse')
				localStorage.removeItem('shopIdInfo')
				localStorage.removeItem('secondPws')
				localStorage.removeItem('storeId')
				location.replace('/loginPage')
				
			},
			ttp(){
				alert(this.userId)
			},
			switchLangq(value){
				this.SWITCH_LANG(value)
				this.$i18n.locale =  value 
				this.reload()
				
			},

			getTime(time){
				return utils.renderTime(time)
			},
			gotopersonal(){
				// const {href}=this.$router.resolve({
				// 	path:'/personal',
				// 	query:{
				// 		key:'resetLoginPws'
				// 	}
				
				// }) 
				// window.open(href)

				this.$router.push({
					path:'/personal',
					query:{
						key:'resetLoginPws',
						from:this.$route.path
					}
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
@import "~@assets/scss/mixins";
	.header {
		position: fixed;
		width: 100%;
		height: $top_header_height;
		background-color: #409eff;
		z-index: 88;
	}

	.header .title-desc {
		float: left;
	}

	.header .cinlg{
		font-size: 16px;
		margin-right: 20px;
		cursor: pointer;
		position:relative;

	}

	/* .header .tubiao{
		margin-right: 1px;
	} */

	.header .header-title {
		display: flex;
		justify-content: space-between;
		font-size: 18px;
		color: #fff;
		padding: 5px 30px;
		text-align: left;
	}


	.header .el-dropdown-link {
		cursor: pointer;
		color: #ffffff;
	}

	.header .el-icon-arrow-down {
		font-size: 12px;
	}

	.el-notification{
		top:77px!important;
	}

	 .notify_btn{
		color:#fff;
		background-color: #409eff;
		border: none;
		border-radius: 3px;
		padding: 4px 8px;
		cursor: pointer;
		position: relative;
        right: -195px;

	}

	.erp_notify{
		margin-top:12px;
		margin-left: -20px;
		margin-bottom: -5px;
		/* color: red; */
		font-weight: bold;
		color: #909399;
	}

	.desc_notify{
		margin-top: 10px;
		margin-left: -20px;
		margin-bottom: 10px;
		padding:5px 0;
		border-bottom: 1px solid #eee;
		color: red;
	}

	.more_notify{
		cursor: pointer;
		color: #409eff;
    	margin-left: -87px;
	}

	.header .demonstration {
		display: block;
		color: #814ca6;
		font-size: 14px;
		widows: 100%;
		margin-bottom: 20px;
	}
	.header .login-btn{
		font-size: 18px;
		
		
	}

	.header .v-modal{
		z-index:2!important;
	}

	.header .el-notification__title{
		color:red;
	}
	
	.header .ttp{
		display: flex;
		align-items: center;
		font-size: 14px;
		position: relative;
	}
	
	.header .toggle{
		width: 120px;
		margin-right: 50px;
	}
	.header .icon-gerenzhongxin{
		font-size: 30px !important;
		color: #fff;
		padding-left: 15px;
		cursor: pointer;
	}
	.header .notice{
		position: absolute;
		top:0;
		right: 250px;
		width: 300px;
		height: 300px;
		color: #000000;
		margin-top: 45px;
		background-color: #fff;
		border-radius: 5px;
		box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
		display: none;
		box-sizing: border-box;
		padding: 5px;
	
		
	}

	.header .line_wrapper{
		display: flex;
		flex-direction: column;
		width: 50px;
		height: 30px;
		justify-content: center;
		
		cursor: pointer;
		
	}

	.header .line{
		display: inline-block;
		width: 25px;
		height: 3px;
		margin: 2px 0;
		padding: 0.5px 0;
		border-radius: 2px;
		background-color: #fff;
	}
	
	.header .active{
		display: block!important;
	}
	
	.fade-enter {
		display: none;
	  opacity:0;
	}
	.fade-leave{
		display: block;
	  opacity:1;
	}
	.fade-enter-active{
	  transition:all 1.5s;
	}
	.fade-leave-active{
	  opacity:0;
	  transition:all 1.5s;
	}

	.news{
		color: #F56C6C;
		font-size: 24px!important;
	}
	
	.el-icon-bell{
		font-size: 20px;
		color: red;
	}
	.unreadMsg{
		color: red;
		font-size: 12px;
	}

	.project-dropdown{
		max-height: 300px;
		overflow: auto

	
	}

	.newTip_cricle{
		color: red;
		font-size: 16px;
		position: absolute;
		top: -10px;
		left: 18px;
	}

	.icon-lianxiwomen{
		font-size: 22px!important;
		margin-right: 10px;

	}

	.new_desc{
		display: inline-block;
		width: 150px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.icon-xiaoxi11{
		font-size: 20px!important;
		margin-right: 6px;
	}

	

	.hehe-enter,.hehe-leave-to{
	opacity: 0;
	}
	.hehe-enter-to,.hehe-leave{
		opacity: 1;
	}
	.hehe-enter-active,.hehe-leave-active{
		transition: all 0.5s;
	}
		
	
	 .header .box {
	            width: 300px;
	            margin: 0 15px;
	            overflow: hidden;
	        }
	 
	        .animate {
	            padding-left: 20px;
	            font-size: 18px;
	            color: #fff;
	            display: inline-block;
	            white-space: nowrap;
	            animation: 15s wordsLoop linear infinite normal;
	        }
	 
	        @keyframes wordsLoop {
	            0% {
	                transform: translateX(200px);
	                -webkit-transform: translateX(200px);
	            }
	            100% {
	                transform: translateX(-100%);
	                -webkit-transform: translateX(-100%);
	            }
	        }
	 
	        @-webkit-keyframes wordsLoop {
	            0% {
	                transform: translateX(200px);
	                -webkit-transform: translateX(200px);
	            }
	            100% {
	                transform: translateX(-100%);
	                -webkit-transform: translateX(-100%);
	            }
	        }


			.newTip {
	           
	           
	            color: #fff;
	            display: inline-block;
	            white-space: nowrap;
	            animation: 8s wordsLoop linear infinite normal;
	        }
	 
	        @keyframes wordsLoop {
	            0% {
	                transform: translateX(20px);
	                -webkit-transform: translateX(50px);
	            }
	            100% {
	                transform: translateX(-50%);
	                -webkit-transform: translateX(-100%);
	            }
	        }
	 
	        @-webkit-keyframes wordsLoop {
	            0% {
	                transform: translateX(20px);
	                -webkit-transform: translateX(20px);
	            }
	            100% {
	                transform: translateX(-50%);
	                -webkit-transform: translateX(-50%);
	            }
	        }
</style>
